//Store here just security free data
const STORAGE_KEY = 'LNL-v0.1.5';

export const localSt = {
	getStorage() {
		return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{"storage": "' + STORAGE_KEY + '"}');
	},
	setStorage(data) {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
	},
	fetch: function (fieldName) {
		let store = this.getStorage();

		return typeof store[fieldName] !== 'undefined' ? store[fieldName] : {};
	},
	save: function (fieldName, data) {
		let store = this.getStorage();
		store[fieldName] = data;
		this.setStorage(store);
	}
};